import axios from "axios";

export default {
  namespaced: true,
  state: {
    id: null,
    code: '',
    name: '',
    shortCode: '',
    subjectId: null,
    subjectName: '',
    gradeId: null,
    gradeName: '',
    difficultyId: null,
    difficultyName: '',
    contentType: '',
    fiscalYear: '',
    questionCnt: '',
    essayQuestionCnt: '',
    shinkenkyuNumber: '',
    questionDetail: '',
    sample: false,
    listeningTime: '',
  },

  getters: {
    title: state => {
      return state.id ? '編集' : ''
    },
    url: state => {
      return `api/v1/admin/contents/${state.id}`
    },
    method: () => {
      return 'PUT'
    },
    data: state => {
      return {
        name: state.name,
        short_code: state.shortCode,
        difficulty_id: state.difficultyId,
        content_type: state.contentType,
        fiscal_year: state.fiscalYear ? parseInt(state.fiscalYear) : null,
        shinkenkyu_number: state.shinkenkyuNumber ? parseInt(state.shinkenkyuNumber) : null,
        essay_question_cnt: state.essayQuestionCnt ? parseInt(state.essayQuestionCnt) : null,
        question_detail: state.questionDetail,
        sample: state.sample,
        listening_time: state.listeningTime,
      };
    },
  },

  mutations: {
    setContent(state, payload) {
      state.id = payload.id;
      state.code = payload.code;
      state.name = payload.name;
      state.shortCode = payload.short_code || '';
      state.subjectId = payload.subject_id;
      state.subjectName = payload.subject_name;
      state.gradeId = payload.grade_id;
      state.gradeName = payload.grade_name;
      state.difficultyId = payload.difficulty_id;
      state.difficultyName = payload.difficulty_name;
      state.contentType = payload.content_type;
      state.fiscalYear = payload.fiscal_year != null ? payload.fiscal_year.toString() : '';
      state.questionCnt = payload.question_cnt != null ? payload.question_cnt.toString() : '';
      state.essayQuestionCnt = payload.essay_question_cnt != null ? payload.essay_question_cnt.toString() : '';
      state.shinkenkyuNumber = payload.shinkenkyu_number != null ? payload.shinkenkyu_number.toString() : '';
      state.questionDetail = payload.question_detail || '';
      state.sample = payload.sample || false;
      state.listeningTime = payload.listening_time || '';
    },
    setName(state, payload) { state.name = payload.name; },
    setShortCode(state, payload) { state.shortCode = payload.shortCode; },
    setDifficultyId(state, payload) { state.difficultyId = payload.difficultyId; },
    setContentType(state, payload) { state.contentType = payload.contentType; },
    setFiscalYear(state, payload) { state.fiscalYear = payload.fiscalYear; },
    setShinkenkyuNumber(state, payload) { state.shinkenkyuNumber = payload.shinkenkyuNumber; },
    setEssayQuestionCnt(state, payload) { state.essayQuestionCnt = payload.essayQuestionCnt; },
    setQuestionDetail(state, payload) { state.questionDetail = payload.questionDetail; },
    setSample(state, payload) { state.sample = payload.sample; },
    setListeningTime(state, payload) { state.listeningTime = payload.listeningTime; },
    initialize(state) {
      state.id = null;
      state.code = '';
      state.name = '';
      state.shortCode = '';
      state.subjectId = null;
      state.subjectName = '';
      state.gradeId = null;
      state.gradeName = '';
      state.difficultyId = null;
      state.difficultyName = '';
      state.contentType = '';
      state.fiscalYear = '';
      state.questionCnt = '';
      state.essayQuestionCnt = '';
      state.shinkenkyuNumber = '';
      state.questionDetail = '';
      state.sample = false;
      state.listeningTime = '';
    },
  },

  actions: {
    async validate({ state }) {
      if (!state.name) return { status: 'error', message: '単元名を入力してください' }
      return { status: 'success', message: '' }
    },
    async submit({ getters }) {
      const content = getters.data
      const url = getters.url
      const method = getters.method

      await axios({
        url: url,
        method: method,
        data: { content: content },
      })

      return { status: 'success', message: '更新が完了しました' }
    },
  },
}
